import { Service, ServiceField } from '@onlog-public/additional-services-types';
import { VerticalTableTemplateStore } from '@pages/AdditionalServices/components/Service/VerticalTableTemplate/types';
import { serviceStateGeneratorProcessor } from '@pages/AdditionalServices/containers/services/serviceStateGenerator/types';
import { v4 } from 'uuid';

/**
 * VerticalTableTemplateProcessor создает базовый стейт для услуг типа "Вертикальная таблица"
 */
export class VerticalTableTemplateProcessor implements serviceStateGeneratorProcessor {
  /**
   * isAvailable проверяет доступность процессора для генерации
   * @param service
   */
  isAvailable(service: Service): boolean {
    return service.template === 'verticalTable';
  }

  /**
   * generate выполняет генерацию стейта по полям и услуге. Возвращает сам стейт.
   * @param service
   * @param fields
   * @param values
   * @param existStore
   */
  generate(service: Service, fields: ServiceField[], values: { [x: string]: number }, _: any) {
    const result: VerticalTableTemplateStore = {
      rows: {},
      rowsDirection: {},
    };

    const costField = fields.find(
      (f) => f.code === service.settings.TemplateSettings.VerticalTable.CostColumnField
    );
    const qtyField = fields.find(
      (f) => f.code === service.settings.TemplateSettings.VerticalTable.RowQuantityField
    );

    if (!qtyField || !costField || !values[qtyField.code]) {
      return result;
    }

    for (let i = 0; i < values[qtyField.code]; i++) {
      const rowID = v4();
      result.rows[rowID] = values[costField.code] ?? 0;
      result.rowsDirection[rowID] = i;
    }

    return result;
  }

  /**
   * restore выполняет генерацию стейта по полям, услуге и восстановленому стейту. Возвращает сам стейт.
   * @param service
   * @param fields
   * @param values
   * @param existStore
   */
  restore(
    service: Service,
    fields: ServiceField[],
    values: { [x: string]: number },
    existStore?: VerticalTableTemplateStore
  ) {
    const existStoreValues = Object.values(existStore?.rows ?? {});

    const result: VerticalTableTemplateStore = {
      rows: {},
      rowsDirection: {},
    };

    const costField = fields.find(
      (f) => f.code === service.settings.TemplateSettings.VerticalTable.CostColumnField
    );
    const qtyField = fields.find(
      (f) => f.code === service.settings.TemplateSettings.VerticalTable.RowQuantityField
    );

    if (!qtyField || !costField || !values[qtyField.code]) {
      return result;
    }

    for (let i = 0; i < values[qtyField.code]; i++) {
      const rowID = v4();
      result.rows[rowID] = existStoreValues?.[i] ?? values[costField.code] ?? 0;
      result.rowsDirection[rowID] = i;
    }

    return result;
  }
}
